import { render, staticRenderFns } from "./WordRatingList.vue?vue&type=template&id=43d0acf7"
import script from "./WordRatingList.vue?vue&type=script&lang=js"
export * from "./WordRatingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports